<template lang="pug">
.card-content(@click="$emit('click')")
  el-card.card-totais(shadow="always" class="box-card")
    h3 {{ setorWithCount.setor.codigo.replace(/_/g, " ") }} - {{  setorWithCount.setor.nome }}
    p Quantidade de processos no setor: {{ setorWithCount.qtdProcessos }}
</template>

<script>

export default {

  props: {
    setorWithCount: {
      type: Object,
      required: true
    }
  }

}
</script>

<style lang="scss" scoped>
  .card-totais {
    cursor: pointer;
    height: 150px;
    background-color: #ffffff;
    color: white !important;
    border: 2px solid #1abc9c;
    margin: 20px 20px 0 20px;
    border-radius: 12px;
    padding: 0 10px;

    &:hover {
      background-color: #1abc9c0a;
    }
  }

  .card-content {
    display: flex;
    flex-direction: column;
  }
</style>



// WEBPACK FOOTER //
// src/screens/produtividade/components/CardSetorProdutividade.vue